export const IconHeadseat = () => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.08398 21.5934L7.17448 21.8208C5.50509 22.2382 4.33398 23.738 4.33398 25.4589V28.9779C4.33398 30.6987 5.50509 32.1986 7.17448 32.6159L10.4361 33.4314C11.1462 33.6089 11.834 33.0719 11.834 32.3399V22.0968C11.834 21.3648 11.1462 20.8278 10.4361 21.0054L8.08398 21.5934ZM8.08398 21.5934V20.6562C8.08398 12.372 14.7997 5.65625 23.084 5.65625C31.3683 5.65625 38.084 12.372 38.084 20.6562V21.5934M38.084 21.5934L38.9935 21.8208C40.6629 22.2382 41.834 23.738 41.834 25.4589V28.9779C41.834 30.6987 40.6629 32.1986 38.9935 32.6159L38.084 32.8434M38.084 21.5934L35.7318 21.0054C35.0217 20.8278 34.334 21.3648 34.334 22.0968V32.3399C34.334 33.0719 35.0217 33.6089 35.7318 33.4314L38.084 32.8434M38.084 32.8434V33.7812V34.7188C38.084 36.7899 36.4051 38.4688 34.334 38.4688H28.709M28.709 38.4688C28.709 36.9155 27.4497 35.6562 25.8965 35.6562H20.2715C18.7182 35.6562 17.459 36.9155 17.459 38.4688C17.459 40.022 18.7182 41.2812 20.2715 41.2812H25.8965C27.4497 41.2812 28.709 40.022 28.709 38.4688Z"
        stroke="#053462"
        strokeWidth="4"
      />
    </svg>
  );
};
